import Modal from '@/components/Modal.vue'

class ModalConfig {
  data = null
  
  /**
   * Specify properties that can be passed into modal component
   * 
   * @param {Object} config  
   */
  static setDefault (config) {
    const data = new ModalConfig()
    data.url = config.url
    data.modalSize = config.modalSize
    data.modalHeadline = config.modalHeadline
    data.modalContent = config.modalContent
    data.modalTextAlign = config.modalTextAlign
    
    return data
  }
}

export default {
  /**
   * 
   * @param {Object} config data that can be passed into fired modal component
   */
  init (config) {
    const modalConfig = ModalConfig.setDefault(config)
    const main = document.querySelector('.page-modal')
    return this.open(main, modalConfig)
  },

  /**
   * 
   * @param {Element} main modal placeholder
   * @param {Object} config data that can be passed into fired modal component
   */
  open (main, config) {
    main.innerHTML = '<div class="modal-app"></div>'
    const el = main.querySelector('.modal-app')
    
    return new Modal({ 
      el,
      propsData: { config },
    })
  },
}


// WEBPACK FOOTER //
// ./src/modules/modal.js